module.exports = __webpack_public_path__ + "img/img_9_technology_retail@3x.775bfc24.png";